import { REFRESH_CREATE_SCREEN_REQUEST, REFRESH_CREATE_SCREEN_RESET } from "../constants/createConstants"

export const getCreateReducer = (state = { }, action) => {
    switch(action.type) {
        case REFRESH_CREATE_SCREEN_REQUEST:
            return {refreshing: true }

        case REFRESH_CREATE_SCREEN_RESET:
            return {refreshing: false }

        default:
            return state
    }
}